export default __webpack_public_path__ + "static/media/rent-rate-growth.aa84a9bb.png";